<template>
  <div class="collapse-item border-top border-dark" v-if="id">
    <a class="text-decoration-none text-dark" data-bs-toggle="collapse" :href="collapseHref" role="button" aria-expanded="false" aria-controls="collapse-note">
      <div class="row pt-4 pb-4">
        <div class="col title" v-if="title">{{ title }}</div>
        <div class="col-auto d-flex align-items-center"><i :id="iconId" class="collapse-icon bi bi-plus"></i></div>
      </div>
    </a>
    <div :id="collapseId" class="collapse">
      <div class="pb-4" v-if="content">
        <p v-for="(item, index) in content" :key="index" v-html="item"></p>
        <div class="mt-3">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapseItem',
  props: {
    id: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    content: {
      type: Array,
      default: null
    }
  },
  computed: {
    iconId: function () {
      return `icon-${this.id}`
    },
    iconHref: function () {
      return `#${this.iconId}`
    },
    collapseId: function () {
      return `collapse-${this.id}`
    },
    collapseHref: function () {
      return `#${this.collapseId}`
    }
  },
  mounted: function () {
    this.handleCollapseEvents()
  },
  methods: {
    handleCollapseEvents: function () {
      const collapse = document.getElementById(this.collapseId)
      collapse.addEventListener('show.bs.collapse', () => {
        $(this.iconHref).toggleClass('bi-plus bi-dash')
      })
      collapse.addEventListener('hide.bs.collapse', () => {
        $(this.iconHref).toggleClass('bi-plus bi-dash')
      })
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 1.5rem;
  font-weight: 700;
  font-family: 'Noto Serif TC', serif;
}
.collapse-icon {
  font-size: 1.5rem;
}
p {
  margin-bottom: 0;
}
</style>
